<template>
    <modal name="form-modal-container" 
        @before-close="beforeFormModalClose" 
        :transition="transitionName" 
        :width="modalWidth" 
        :height="modalHeight" 
        :scrollable="modalScrollable"  
        class="form-modal-container"               
        id="form-modal-container">
        <div class="modal-content" v-if="formsData != null">
            <formOfModal 
                :imgForm="formsGlobalParam == 'grat' ? formsData.form_contacts.img_grat : formsGlobalParam == 'call' ? formsData.form_contacts.img_call : formsGlobalParam == 'call-page' ? formsData.form_contacts.img_consult : formsGlobalParam == 'call-page-get' ? formsData.form_contacts.img_consult_get : formsData.form_contacts.img_estate" 
                :titleForm="formsGlobalParam == 'grat' ? formsData.form_contacts.title_compliment : formsGlobalParam == 'call' ? formsData.form_contacts.title_call : formsGlobalParam == 'call-page' ? formsData.form_contacts.title_consult : formsGlobalParam == 'call-page-get' ? formsData.form_contacts.title_consult_get : formsData.form_contacts.title_estate"
                :completeTitle="formsGlobalParam == 'grat' ? formsData.form_contacts.complete_msg : formsGlobalParam == 'call' ? formsData.form_contacts.complete_msg_call : formsGlobalParam == 'call-page' ? formsData.form_contacts.complete_msg_call_page : formsGlobalParam == 'call-page-get' ? formsData.form_contacts.complete_msg_call_page_get : formsData.form_contacts.complete_msg_estate"
            ></formOfModal>
        </div>
    </modal>
</template>

<script>
    import formOfModal from '@/components/forms/forms-of-modal/form-of-modal.vue'
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        components: {
            svgIcon,
            formOfModal,
        },
        data () {
            return {
                transitionName: 'pop-out',
                modalWidth: 755,
                modalHeight: 'auto',
                modalScrollable: false,
                formVisibleParam: 'call',
            }
        },
        computed: mapGetters({
            formsGlobalParam: 'loadFormsGlobalParam',
            formsData: 'loadFormsData',
        }),
        methods: {
            beforeFormModalClose() {
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                // document.getElementById('header').classList.remove('notvisible');
            },
            openFormModalContainer() {
                this.$modal.show('form-modal-container');
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
            },
        },
        created () {
        },
        destroyed() {
        },  
        mounted () {
            this.$store.watch(
                (state) => state.formModalContainerInit,
                (newValue) => {
                    if (newValue) {
                        // this.correctFindWord();
                        this.openFormModalContainer();
                        // console.log(newValue, 'NEW NEW')
                    }
                }
            );
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-modal-container.scss';
    // @import '@/styles/components/forms/respond/form-page-respond.scss';
</style>